export const API_BASE = import.meta.env.VITE_API_URL ?? 'https://api.tw3002.net';

function optionalUrl(value: string | undefined): string | null {
  const normalized = value?.trim();
  return normalized ? normalized : null;
}

function configurableUrl(value: string | undefined, fallback: string): string | null {
  if (value === undefined) return fallback;
  return optionalUrl(value);
}

export const MAIN_SITE_URL = import.meta.env.VITE_MAIN_SITE_URL ?? 'https://tw3002.net';
export const CHANGELOG_URL = import.meta.env.VITE_CHANGELOG_URL ?? `${MAIN_SITE_URL}/changelog/`;
export const GUIDE_URL = configurableUrl(import.meta.env.VITE_GUIDE_URL, `${MAIN_SITE_URL}/guide/getting-started`);
export const COMMUNITY_URL = configurableUrl(import.meta.env.VITE_COMMUNITY_URL, 'https://discord.gg/CCBHEJWzQa');
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '0x4AAAAAADIgFsuw7omMEkIh';
